// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---- from App.css lines 6259-6698 ---- */
/* ===== LAP LIST (PilotLive) - Premium F1 Style ===== */
.lap-header {
  display: grid;
  grid-template-columns: 70px 1fr 1fr 120px;
  gap: 12px;
  padding: 14px 16px;
  margin: 16px 0 10px;
  border: 1px solid rgba(192, 255, 3, 0.3);
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.08), rgba(150, 200, 0, 0.05));
  font-weight: 900;
  font-size: 0.8rem;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.lap-list {
  max-height: 40vh;
  overflow-y: auto;
  padding-right: 4px;
  margin-top: 8px;
}

.lap-list::-webkit-scrollbar {
  width: 6px;
}

.lap-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
}

.lap-list::-webkit-scrollbar-thumb {
  background: rgba(192, 255, 3, 0.4);
  border-radius: 3px;
}

.lap-list::-webkit-scrollbar-thumb:hover {
  background: rgba(192, 255, 3, 0.6);
}

.lap-row {
  display: grid;
  grid-template-columns: 70px 1fr 1fr 120px;
  gap: 10px;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(20, 20, 20, 0.6), rgba(10, 10, 10, 0.5));
  transition: all .25s ease;
  position: relative;
  overflow: hidden;
}

.lap-row::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: rgba(255, 255, 255, 0.1);
  transition: all .25s ease;
}

.lap-row:hover {
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.8), rgba(20, 20, 20, 0.7));
  border-color: rgba(192, 255, 3, 0.4);
  transform: translateX(4px);
  box-shadow: 0 4px 16px rgba(192, 255, 3, 0.15);
}

.lap-row:hover::before {
  background: var(--brand);
  width: 4px;
  box-shadow: 0 0 12px var(--brand);
}

.lap-row.is-pb {
  border-color: rgba(176, 133, 255, 0.4);
  background: linear-gradient(135deg, rgba(176, 133, 255, 0.12), rgba(130, 80, 200, 0.08));
}

.lap-row.is-pb::before {
  background: linear-gradient(180deg, #b085ff, #8c5dd8);
  width: 4px;
  box-shadow: 0 0 16px rgba(176, 133, 255, 0.6);
}

.lap-row.is-pb .lap-time {
  color: #d4b3ff;
  font-weight: 900;
  text-shadow: 0 0 12px rgba(176, 133, 255, 0.4);
}

.lap-row.is-last {
  border-color: rgba(33, 193, 48, 0.4);
  background: linear-gradient(135deg, rgba(33, 193, 48, 0.12), rgba(20, 150, 30, 0.08));
}

.lap-row.is-last::before {
  background: linear-gradient(180deg, #21c130, #15a020);
  width: 4px;
  box-shadow: 0 0 16px rgba(33, 193, 48, 0.6);
}

.lap-row.is-last .lap-time {
  color: #e9ffe0;
  font-weight: 900;
  text-shadow: 0 0 12px rgba(33, 193, 48, 0.4);
}

.lap-pos {
  font-weight: 900;
  font-size: 1.1rem;
  color: var(--brand);
  text-align: center;
  font-family: 'Courier New', monospace;
  text-shadow: 0 2px 8px rgba(192, 255, 3, 0.3);
}

.lap-time {
  font-weight: 800;
  font-size: 1rem;
  color: #ffffff;
  font-family: 'Courier New', monospace;
  letter-spacing: 0.5px;
}

.lap-delta {
  font-weight: 800;
  font-size: 0.95rem;
  text-align: right;
  color: #ff6b6b;
  font-family: 'Courier New', monospace;
}

.lap-badges {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.badge {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: .75rem;
  font-weight: 900;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  border: 1px solid var(--line);
  background: var(--glass);
  color: #fff;
  transition: all .2s ease;
}

.badge-pb {
  color: #d4b3ff;
  border-color: rgba(176, 133, 255, .6);
  background: linear-gradient(135deg, rgba(176, 133, 255, 0.2), rgba(130, 80, 200, 0.15));
  box-shadow: 0 0 12px rgba(176, 133, 255, 0.3);
}

.badge-last {
  color: #e9ffe0;
  border-color: rgba(33, 193, 48, .6);
  background: linear-gradient(135deg, rgba(33, 193, 48, 0.2), rgba(20, 150, 30, 0.15));
  box-shadow: 0 0 12px rgba(33, 193, 48, 0.3);
}

/* ===== PILOT STATS GRID (PilotLive) - Premium Style ===== */
.lb-list .lb-row {
  /* padding: 16px 20px; */
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

.lb-list .lb-row:hover {
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.5), rgba(20, 20, 20, 0.4));
  border-color: rgba(192, 255, 3, 0.3);
  transform: translateX(-2px);
}

/* Stats grid rows in pilot detail */
.leaderboard-card .lb-row>div {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
  position: relative;
}

.leaderboard-card .lb-row>div .muted {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
}

.leaderboard-card .lb-row>div>div:last-child {
  font-size: 1.3rem;
  font-weight: 900;
  color: white;
  font-family: 'Courier New', monospace;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 8px rgba(255, 255, 255, 0.2);
  transition: all 0.2s ease;
}

.lb-list .lb-row:hover .leaderboard-card .lb-row>div>div:last-child {
  text-shadow: 0 0 16px rgba(192, 255, 3, 0.4), 0 2px 8px rgba(255, 255, 255, 0.3);
  transform: scale(1.02);
}

/* Sector times - colored indicators */
.leaderboard-card .lb-row .sector-pb {
  color: #b085ff !important;
  text-shadow: 0 0 12px rgba(176, 133, 255, 0.6) !important;
}

/* Pilot detail header enhancement */
.leaderboard-card .lb-header {
  position: relative;
  overflow: hidden;
}

.leaderboard-card .lb-header::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  height: 0%;
  background: linear-gradient(90deg, transparent, rgba(192, 255, 3, 0.05));
  pointer-events: none;
}

/* Premium animations for pilot page */
@keyframes subtle-pulse {

  0%,
  100% {
    opacity: 1;
    text-shadow: 0 2px 8px rgba(255, 255, 255, 0.2);
  }

  50% {
    opacity: 0.95;
    text-shadow: 0 2px 12px rgba(192, 255, 3, 0.3), 0 0 20px rgba(192, 255, 3, 0.2);
  }
}

/* Apply subtle pulse to key stats (position) */
.leaderboard-card .lb-row>div:first-child>div:last-child {
  animation: subtle-pulse 3s ease-in-out infinite;
}

/* Enhanced scrollbar for pilot page */
.pilot-form .lap-list::-webkit-scrollbar {
  width: 8px;
}

.pilot-form .lap-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 4px;
  margin: 4px 0;
}

.pilot-form .lap-list::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, rgba(192, 255, 3, 0.5), rgba(150, 200, 0, 0.4));
  border-radius: 4px;
  box-shadow: 0 0 8px rgba(192, 255, 3, 0.3);
}

.pilot-form .lap-list::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, rgba(192, 255, 3, 0.7), rgba(150, 200, 0, 0.6));
  box-shadow: 0 0 12px rgba(192, 255, 3, 0.5);
}

/* ===== NUOVO LAYOUT PAGINA PILOTA - PREMIUM COMPLETO ===== */

.pilot-stats-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
}

.pilot-telemetry-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.pilot-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.pilot-stats-row-half {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.pilot-stats-row-sectors {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.pilot-stat-card {
  background: linear-gradient(135deg, rgba(20, 20, 20, 0.9), rgba(10, 10, 10, 0.85));
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 16px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.pilot-stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, rgba(192, 255, 3, 0.5), transparent);
  opacity: 0.6;
}

.pilot-stat-card:hover {
  transform: translateY(-2px);
  border-color: rgba(192, 255, 3, 0.4);
  box-shadow: 0 8px 24px rgba(192, 255, 3, 0.15);
}

.pilot-stat-card--highlight {
  border-color: rgba(176, 133, 255, 0.4);
  background: linear-gradient(135deg, rgba(176, 133, 255, 0.12), rgba(130, 80, 200, 0.08));
}

.pilot-stat-card--highlight::before {
  background: linear-gradient(90deg, rgba(176, 133, 255, 0.8), transparent);
}

.pilot-stat-card--highlight:hover {
  border-color: rgba(176, 133, 255, 0.6);
  box-shadow: 0 8px 24px rgba(176, 133, 255, 0.2);
}

.pilot-stat-label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
}

.pilot-stat-value {
  font-size: 1.8rem;
  font-weight: 900;
  color: white;
  font-family: 'Courier New', monospace;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 12px rgba(255, 255, 255, 0.2);
}

.pilot-stat-card--highlight .pilot-stat-value {
  color: #d4b3ff;
  text-shadow: 0 2px 12px rgba(176, 133, 255, 0.4);
}

.pilot-laps-section {
  background: linear-gradient(135deg, rgba(20, 20, 20, 0.5), rgba(10, 10, 10, 0.4));
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 24px;
  position: relative;
  overflow: hidden;
}

.pilot-laps-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, rgba(192, 255, 3, 0.6), transparent);
  opacity: 0.8;
}

.pilot-section-title {
  font-size: 1.2rem;
  font-weight: 900;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--brand);
  margin-bottom: 20px;
  text-shadow: 0 2px 8px rgba(192, 255, 3, 0.3);
}

.pilot-track-section {
  margin-top: 24px;
}

.pilot-track-section .track-card {
  width: 100%;
  min-height: 500px;
}

/* Responsive */
@media (max-width: 1024px) {
  .pilot-telemetry-section {
    grid-template-columns: 1fr;
  }

  .pilot-stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}

@media (max-width: 768px) {
  .pilot-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/legacy/pilotlive-legacy.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C,wDAAwD;AACxD;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,iFAAiF;AACnF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,iFAAiF;EACjF,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,iFAAiF;EACjF,oCAAoC;EACpC,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,wFAAwF;AAC1F;;AAEA;EACE,qDAAqD;EACrD,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,qFAAqF;AACvF;;AAEA;EACE,qDAAqD;EACrD,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uFAAuF;EACvF,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,oFAAoF;EACpF,2CAA2C;AAC7C;;AAEA,6DAA6D;AAC7D;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iFAAiF;EACjF,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,qBAAqB;EACrB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,gFAAgF;EAChF,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,wEAAwE;EACxE,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;;EAEE;;IAEE,UAAU;IACV,+CAA+C;EACjD;;EAEA;IACE,aAAa;IACb,+EAA+E;EACjF;AACF;;AAEA,+CAA+C;AAC/C;EACE,+CAA+C;AACjD;;AAEA,sCAAsC;AACtC;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mFAAmF;EACnF,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,mFAAmF;EACnF,2CAA2C;AAC7C;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uEAAuE;EACvE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,wFAAwF;AAC1F;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,iFAAiF;EACjF,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uEAAuE;EACvE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* ---- from App.css lines 6259-6698 ---- */\n/* ===== LAP LIST (PilotLive) - Premium F1 Style ===== */\n.lap-header {\n  display: grid;\n  grid-template-columns: 70px 1fr 1fr 120px;\n  gap: 12px;\n  padding: 14px 16px;\n  margin: 16px 0 10px;\n  border: 1px solid rgba(192, 255, 3, 0.3);\n  border-radius: 12px;\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.08), rgba(150, 200, 0, 0.05));\n  font-weight: 900;\n  font-size: 0.8rem;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.7);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1);\n}\n\n.lap-list {\n  max-height: 40vh;\n  overflow-y: auto;\n  padding-right: 4px;\n  margin-top: 8px;\n}\n\n.lap-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.lap-list::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 3px;\n}\n\n.lap-list::-webkit-scrollbar-thumb {\n  background: rgba(192, 255, 3, 0.4);\n  border-radius: 3px;\n}\n\n.lap-list::-webkit-scrollbar-thumb:hover {\n  background: rgba(192, 255, 3, 0.6);\n}\n\n.lap-row {\n  display: grid;\n  grid-template-columns: 70px 1fr 1fr 120px;\n  gap: 10px;\n  align-items: center;\n  padding: 8px 12px;\n  margin-bottom: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  background: linear-gradient(135deg, rgba(20, 20, 20, 0.6), rgba(10, 10, 10, 0.5));\n  transition: all .25s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.lap-row::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: rgba(255, 255, 255, 0.1);\n  transition: all .25s ease;\n}\n\n.lap-row:hover {\n  background: linear-gradient(135deg, rgba(30, 30, 30, 0.8), rgba(20, 20, 20, 0.7));\n  border-color: rgba(192, 255, 3, 0.4);\n  transform: translateX(4px);\n  box-shadow: 0 4px 16px rgba(192, 255, 3, 0.15);\n}\n\n.lap-row:hover::before {\n  background: var(--brand);\n  width: 4px;\n  box-shadow: 0 0 12px var(--brand);\n}\n\n.lap-row.is-pb {\n  border-color: rgba(176, 133, 255, 0.4);\n  background: linear-gradient(135deg, rgba(176, 133, 255, 0.12), rgba(130, 80, 200, 0.08));\n}\n\n.lap-row.is-pb::before {\n  background: linear-gradient(180deg, #b085ff, #8c5dd8);\n  width: 4px;\n  box-shadow: 0 0 16px rgba(176, 133, 255, 0.6);\n}\n\n.lap-row.is-pb .lap-time {\n  color: #d4b3ff;\n  font-weight: 900;\n  text-shadow: 0 0 12px rgba(176, 133, 255, 0.4);\n}\n\n.lap-row.is-last {\n  border-color: rgba(33, 193, 48, 0.4);\n  background: linear-gradient(135deg, rgba(33, 193, 48, 0.12), rgba(20, 150, 30, 0.08));\n}\n\n.lap-row.is-last::before {\n  background: linear-gradient(180deg, #21c130, #15a020);\n  width: 4px;\n  box-shadow: 0 0 16px rgba(33, 193, 48, 0.6);\n}\n\n.lap-row.is-last .lap-time {\n  color: #e9ffe0;\n  font-weight: 900;\n  text-shadow: 0 0 12px rgba(33, 193, 48, 0.4);\n}\n\n.lap-pos {\n  font-weight: 900;\n  font-size: 1.1rem;\n  color: var(--brand);\n  text-align: center;\n  font-family: 'Courier New', monospace;\n  text-shadow: 0 2px 8px rgba(192, 255, 3, 0.3);\n}\n\n.lap-time {\n  font-weight: 800;\n  font-size: 1rem;\n  color: #ffffff;\n  font-family: 'Courier New', monospace;\n  letter-spacing: 0.5px;\n}\n\n.lap-delta {\n  font-weight: 800;\n  font-size: 0.95rem;\n  text-align: right;\n  color: #ff6b6b;\n  font-family: 'Courier New', monospace;\n}\n\n.lap-badges {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.badge {\n  display: inline-block;\n  padding: 5px 12px;\n  border-radius: 999px;\n  font-size: .75rem;\n  font-weight: 900;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  border: 1px solid var(--line);\n  background: var(--glass);\n  color: #fff;\n  transition: all .2s ease;\n}\n\n.badge-pb {\n  color: #d4b3ff;\n  border-color: rgba(176, 133, 255, .6);\n  background: linear-gradient(135deg, rgba(176, 133, 255, 0.2), rgba(130, 80, 200, 0.15));\n  box-shadow: 0 0 12px rgba(176, 133, 255, 0.3);\n}\n\n.badge-last {\n  color: #e9ffe0;\n  border-color: rgba(33, 193, 48, .6);\n  background: linear-gradient(135deg, rgba(33, 193, 48, 0.2), rgba(20, 150, 30, 0.15));\n  box-shadow: 0 0 12px rgba(33, 193, 48, 0.3);\n}\n\n/* ===== PILOT STATS GRID (PilotLive) - Premium Style ===== */\n.lb-list .lb-row {\n  /* padding: 16px 20px; */\n  margin-bottom: 10px;\n  transition: all 0.3s ease;\n}\n\n.lb-list .lb-row:hover {\n  background: linear-gradient(135deg, rgba(30, 30, 30, 0.5), rgba(20, 20, 20, 0.4));\n  border-color: rgba(192, 255, 3, 0.3);\n  transform: translateX(-2px);\n}\n\n/* Stats grid rows in pilot detail */\n.leaderboard-card .lb-row>div {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-start;\n  position: relative;\n}\n\n.leaderboard-card .lb-row>div .muted {\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.leaderboard-card .lb-row>div>div:last-child {\n  font-size: 1.3rem;\n  font-weight: 900;\n  color: white;\n  font-family: 'Courier New', monospace;\n  letter-spacing: 0.5px;\n  text-shadow: 0 2px 8px rgba(255, 255, 255, 0.2);\n  transition: all 0.2s ease;\n}\n\n.lb-list .lb-row:hover .leaderboard-card .lb-row>div>div:last-child {\n  text-shadow: 0 0 16px rgba(192, 255, 3, 0.4), 0 2px 8px rgba(255, 255, 255, 0.3);\n  transform: scale(1.02);\n}\n\n/* Sector times - colored indicators */\n.leaderboard-card .lb-row .sector-pb {\n  color: #b085ff !important;\n  text-shadow: 0 0 12px rgba(176, 133, 255, 0.6) !important;\n}\n\n/* Pilot detail header enhancement */\n.leaderboard-card .lb-header {\n  position: relative;\n  overflow: hidden;\n}\n\n.leaderboard-card .lb-header::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 200px;\n  height: 0%;\n  background: linear-gradient(90deg, transparent, rgba(192, 255, 3, 0.05));\n  pointer-events: none;\n}\n\n/* Premium animations for pilot page */\n@keyframes subtle-pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n    text-shadow: 0 2px 8px rgba(255, 255, 255, 0.2);\n  }\n\n  50% {\n    opacity: 0.95;\n    text-shadow: 0 2px 12px rgba(192, 255, 3, 0.3), 0 0 20px rgba(192, 255, 3, 0.2);\n  }\n}\n\n/* Apply subtle pulse to key stats (position) */\n.leaderboard-card .lb-row>div:first-child>div:last-child {\n  animation: subtle-pulse 3s ease-in-out infinite;\n}\n\n/* Enhanced scrollbar for pilot page */\n.pilot-form .lap-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.pilot-form .lap-list::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 4px;\n  margin: 4px 0;\n}\n\n.pilot-form .lap-list::-webkit-scrollbar-thumb {\n  background: linear-gradient(180deg, rgba(192, 255, 3, 0.5), rgba(150, 200, 0, 0.4));\n  border-radius: 4px;\n  box-shadow: 0 0 8px rgba(192, 255, 3, 0.3);\n}\n\n.pilot-form .lap-list::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(180deg, rgba(192, 255, 3, 0.7), rgba(150, 200, 0, 0.6));\n  box-shadow: 0 0 12px rgba(192, 255, 3, 0.5);\n}\n\n/* ===== NUOVO LAYOUT PAGINA PILOTA - PREMIUM COMPLETO ===== */\n\n.pilot-stats-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.pilot-telemetry-section {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.pilot-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.pilot-stats-row-half {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.pilot-stats-row-sectors {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.pilot-stat-card {\n  background: linear-gradient(135deg, rgba(20, 20, 20, 0.9), rgba(10, 10, 10, 0.85));\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 16px;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.pilot-stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, rgba(192, 255, 3, 0.5), transparent);\n  opacity: 0.6;\n}\n\n.pilot-stat-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(192, 255, 3, 0.4);\n  box-shadow: 0 8px 24px rgba(192, 255, 3, 0.15);\n}\n\n.pilot-stat-card--highlight {\n  border-color: rgba(176, 133, 255, 0.4);\n  background: linear-gradient(135deg, rgba(176, 133, 255, 0.12), rgba(130, 80, 200, 0.08));\n}\n\n.pilot-stat-card--highlight::before {\n  background: linear-gradient(90deg, rgba(176, 133, 255, 0.8), transparent);\n}\n\n.pilot-stat-card--highlight:hover {\n  border-color: rgba(176, 133, 255, 0.6);\n  box-shadow: 0 8px 24px rgba(176, 133, 255, 0.2);\n}\n\n.pilot-stat-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.pilot-stat-value {\n  font-size: 1.8rem;\n  font-weight: 900;\n  color: white;\n  font-family: 'Courier New', monospace;\n  letter-spacing: 0.5px;\n  text-shadow: 0 2px 12px rgba(255, 255, 255, 0.2);\n}\n\n.pilot-stat-card--highlight .pilot-stat-value {\n  color: #d4b3ff;\n  text-shadow: 0 2px 12px rgba(176, 133, 255, 0.4);\n}\n\n.pilot-laps-section {\n  background: linear-gradient(135deg, rgba(20, 20, 20, 0.5), rgba(10, 10, 10, 0.4));\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  padding: 24px;\n  position: relative;\n  overflow: hidden;\n}\n\n.pilot-laps-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, rgba(192, 255, 3, 0.6), transparent);\n  opacity: 0.8;\n}\n\n.pilot-section-title {\n  font-size: 1.2rem;\n  font-weight: 900;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: var(--brand);\n  margin-bottom: 20px;\n  text-shadow: 0 2px 8px rgba(192, 255, 3, 0.3);\n}\n\n.pilot-track-section {\n  margin-top: 24px;\n}\n\n.pilot-track-section .track-card {\n  width: 100%;\n  min-height: 500px;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .pilot-telemetry-section {\n    grid-template-columns: 1fr;\n  }\n\n  .pilot-stats-grid {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .pilot-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
